import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import md5 from 'js-md5';

var JsonConvert = function JsonConvert(data) {
  var result = "";

  if (data != null) {
    for (var p in data) {
      //遍历json对象的每个key/value对,p为key
      result += p + "=" + data[p] + "&";
    }

    result = result.substr(0, result.length - 1);
  }

  return result;
};
/**
 * @name: Saiu
 * @msg:  密码加密，
 * @param {pwd}原密码 {salte}加盐
 * @return: 返回加密后的数据
 */


var DecPwd = function DecPwd(pwd, salte) {
  var res = '';

  if (salte == '') {
    var md5byte = md5(StringToBytes(pwd));
    res = md5byte;
  } else {
    var md5byte = md5(StringToBytes(pwd + salte));
    res = md5byte;
  }

  return res;
};
/**
 * string 转 byte
 * @param str
 */


var StringToBytes = function StringToBytes(str) {
  var bytes = new Array();
  var len, c;
  len = str.length;

  for (var i = 0; i < len; i++) {
    c = str.charCodeAt(i);

    if (c >= 0x010000 && c <= 0x10FFFF) {
      bytes.push(c >> 18 & 0x07 | 0xF0);
      bytes.push(c >> 12 & 0x3F | 0x80);
      bytes.push(c >> 6 & 0x3F | 0x80);
      bytes.push(c & 0x3F | 0x80);
    } else if (c >= 0x000800 && c <= 0x00FFFF) {
      bytes.push(c >> 12 & 0x0F | 0xE0);
      bytes.push(c >> 6 & 0x3F | 0x80);
      bytes.push(c & 0x3F | 0x80);
    } else if (c >= 0x000080 && c <= 0x0007FF) {
      bytes.push(c >> 6 & 0x1F | 0xC0);
      bytes.push(c & 0x3F | 0x80);
    } else {
      bytes.push(c & 0xFF);
    }
  }

  return bytes;
};

var SortField = function SortField(property, order) {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];

    if (order == 'desc') {
      return value2 - value1;
    } else {
      return value1 - value2;
    }
  };
}; ///时间过滤器


var dateFormat = {
  padLeftZero: function padLeftZero(str) {
    return ('00' + str).substr(str.length);
  },
  formatDate: function formatDate(date, fmt) {
    date.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');

    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }

    var o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    };

    for (var k in o) {
      if (new RegExp("(".concat(k, ")")).test(fmt)) {
        var str = o[k] + '';
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : this.padLeftZero(str));
      }
    }

    return fmt;
  }
};

var dateAdd = function dateAdd(interval, number, objDate) {
  var k = dateFormat.formatDate(objDate, 'yyyy-MM-dd hh:mm:ss');
  var d = new Date(k);
  var k = {
    'y': 'FullYear',
    'q': 'Month',
    'm': 'Month',
    'w': 'Date',
    'd': 'Date',
    'h': 'Hours',
    'n': 'Minutes',
    's': 'Seconds',
    'ms': 'MilliSeconds'
  };
  var n = {
    'q': 3,
    'w': 7
  };
  eval('d.set' + k[interval] + '(d.get' + k[interval] + '()+' + (n[interval] || 1) * number + ')');
  return d;
};

var toTree = function toTree(data) {
  var result = [];

  if (!Array.isArray(data)) {
    return result;
  }

  data.forEach(function (item) {
    delete item.children;
  });
  var map = {};
  data.forEach(function (item) {
    map[item.id] = item;
  });
  data.forEach(function (item) {
    var parent = map[item.pid];

    if (parent) {
      (parent.children || (parent.children = [])).push(item);
    } else {
      result.push(item);
    }
  });
  return result;
};

var GroupbyName = function GroupbyName(data, Name) {
  var map = {},
      dest = [];

  for (var i = 0; i < data.length; i++) {
    var ai = data[i];

    if (!map[ai[Name]]) {
      dest.push({
        name: ai[Name],
        data: [ai]
      });
      map[ai[Name]] = ai;
    } else {
      for (var j = 0; j < dest.length; j++) {
        var dj = dest[j];

        if (dj.name == ai[Name]) {
          dj.data.push(ai);
          break;
        }
      }
    }
  }

  return dest;
};

var getchild = function getchild(oldArr, newArr, id) {
  for (var i = 0; i < oldArr.length; i++) {
    if (oldArr[i].parentId == id) {
      newArr.push(oldArr[i].id);
      getchild(oldArr, newArr, oldArr[i].id);
    } else {
      continue;
    }
  }

  return newArr;
};

var getScalechild = function getScalechild(oldArr, newArr, id) {
  for (var i = 0; i < oldArr.length; i++) {
    if (oldArr[i].beltScaleID == id) {
      newArr.push(oldArr[i].scaleRackID);
      getScalechild(oldArr, newArr, oldArr[i].scaleRackID);
    } else {
      continue;
    }
  }

  return newArr;
};

var getRackRollerChild = function getRackRollerChild(oldArr, newArr, id) {
  for (var i = 0; i < oldArr.length; i++) {
    if (oldArr[i].ScaleRackID == id) {
      newArr.push(oldArr[i].ID);
      getRackRollerChild(oldArr, newArr, oldArr[i].ID);
    } else {
      continue;
    }
  }

  return newArr;
};

var getElectricMotorChild = function getElectricMotorChild(oldArr, newArr, id) {
  for (var i = 0; i < oldArr.length; i++) {
    if (oldArr[i].RollerID == id) {
      newArr.push(oldArr[i].ID);
      getElectricMotorChild(oldArr, newArr, oldArr[i].ID);
    } else {
      continue;
    }
  }

  return newArr;
};

var IdPath = function IdPath(data, id, indexArray) {
  console.log('111111111111111111');
  console.log(data);
  var arr = Array.from(indexArray);

  for (var i = 0, len = data.length; i < len; i++) {
    arr.push(data[i].id);

    if (data[i].id === id) {
      return arr;
    }

    var children = data[i].children;

    if (children && children.length) {
      var result = IdPath(children, id, arr);
      if (result) return result;
    }

    arr.pop();
  }

  return false;
};

export { DecPwd, StringToBytes, dateFormat, SortField, toTree, dateAdd, GroupbyName, getchild, getScalechild, getRackRollerChild, getElectricMotorChild, IdPath };